import { createContextHook } from '@/utils';
import { VisitorContext } from './VisitorContext';

export const useVisitorContext = createContextHook(VisitorContext);
